/**
 * Возвращает id картинки для записи по значению
 * @param value значение поля
 * @param field название поля
 * @returns Возвращает индекс картинки
 */
export const orgGetImage = (value: number | string, field: string) => {
  if (field === "CloseDate") {
    return Number(value) > 0 ? 154 : 0;
  }

  if (Number(value) > 0) {
    return 54;
  }

  if (value === "-1") {
    return 3;
  }

  return -value;
};
